import React, {useState, useEffect, forwardRef, useImperativeHandle } from 'react'
import api from './api/api'
import { useNavigate,useLocation } from 'react-router-dom';
import '../css/NotebookList.css'
import ConfirmDialog from './utils/ConfirmDialog'

const NotebookList = forwardRef(({onSaveToExistingNotebookClick, onCreateNewNotebookClick, onCancelClick}, ref) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);   
  const [notebookList, setNotebookList] = useState([]);
  const [selectedNote, setSelectedNote] = useState(null);  
  const [showNewNoteDialog, setShowNewNoteDialog] = useState(false);
  const [notebookSaveMessageVisible, setNotebookSaveMessageVisible] = useState(false); // メッセージの表示状態

  const fetchNotebookList = async () => {
    try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/chat/api/insight-note-list/`, {});
        setNotebookList(response.data);
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            // 未認証の場合、ログイン画面にリダイレクト
            navigate('/login', { state: { from: location.pathname } });
        } else {
            console.error('Error fetching financial summary:', error);
        }
    }
  }


  useEffect(() => {
    fetchNotebookList();
  }, [])

  // 親コンポーネントからref経由で呼び出せるようにする
  useImperativeHandle(ref, () => ({
    fetchNotebookList,  // 親から呼び出せるメソッドとして公開
  }));

  
  const displayConfirmDialog = (note) => {
      setSelectedNote(
        {
          id: note.id,
          title: note.title,
      });
      setShowConfirmDialog(true);
  }

  const displayNewNoteDialog = () => {
      setShowNewNoteDialog(true);
  }

  const cancelNewNoteDialog = () => {
    setShowNewNoteDialog(false);
  }
  
  const okNewNoteDialog = (title) => {
    setShowNewNoteDialog(false);
    onCreateNewNotebookClick(title);
  }

  const cancelConfirmDialog = () => {
    setShowConfirmDialog(false);
  }
  
  const okConfirmDialog = (noteId) => {
    setShowConfirmDialog(false);
    onSaveToExistingNotebookClick(noteId);
    showSaveMessage();
  }

  // 保存メッセージを表示して、3秒後に非表示にする
  const showSaveMessage = () => {
    setNotebookSaveMessageVisible(true);
    setTimeout(() => {
      setNotebookSaveMessageVisible(false);
    }, 1000); // 3秒後に非表示にする
  }
  
  return (
    <div className="notebook-list-container w-[800px] max-w-[100%]  ">
        <div className="notebook-list">
            {notebookSaveMessageVisible && (
              <div className="notebook-save-message">保存しました</div> // メッセージを表示
            )}
            <div className="notebook-list-introduction">どのノートに保存しますか？</div>
            <ul className="notebook-list-ul">
                <li className="notebook-list-li new-note" onClick={() => displayNewNoteDialog()}>新しいノートを作成する <i className="fa-solid fa-plus"></i></li>
                {notebookList.map((note) => (
                  <li className="notebook-list-li existing-note" data-note-id={note.id} onClick={() => displayConfirmDialog(note)}>{note.title}</li>
                ))}
            </ul>
            <div className="save-notebook">
                <div className="save-notebook-button save-notebook-cancel" onClick={onCancelClick}>閉じる</div>
            </div>
        </div>
        {showConfirmDialog ? <ConfirmDialog message={`「${selectedNote.title}」に保存しますか？`} onCancelClick={cancelConfirmDialog} onOkClick={() => okConfirmDialog(selectedNote.id)} /> : null} 
        {showNewNoteDialog ? <NewNoteDialog onCancelClick={cancelNewNoteDialog} onOkClick={okNewNoteDialog} /> : null} 
    </div>
  )
});

export default NotebookList

const NewNoteDialog = ({onOkClick, onCancelClick}) => {
  const [title, setTitle] = useState('')
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
        onOkClick(title);
    }
  }

  return (
    <div id="new-note-dialog" className="confirm-modal">
            <div className="confirm-modal-content">
                <p>ノートのタイトルを入力してください</p>
                <input 
                  type="text" 
                  id="new-note-title" 
                  className="confirm-modal-input" 
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  onKeyDown={handleKeyDown}
                  />
                <div className="confirm-modal-buttons">
                    <button className="confirm-modal-button confirm-yes" onClick={() => onOkClick(title)}>OK</button>
                    <button className="confirm-modal-button confirm-no" onClick={onCancelClick}>キャンセル</button>
                </div>
            </div>
        </div>
  )
}
